import React, { FC } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Box } from '~Styles';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const Wrapper = styled.div<{ animationDelay?: number }>`
  display: flex;
  justify-content: space-between;
  background-color: var(--colorBlueGray1100);
  border: 1px solid var(--colorBlueGray1000);
  border-radius: 8px;
  padding: 0px 16px;
  height: 66px;
  position: relative;
  overflow: hidden;
  width: 100%;
  animation: ${pulse} 2s ease-in-out infinite;
  animation-delay: ${(props) => props.animationDelay || 0}ms;
`;

const IconSkeleton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: var(--colorBlueGray1000);
  flex-shrink: 0;
`;

const TextSkeleton = styled.div`
  height: 20px;
  max-width: 120px;
  width: 100%;
  border-radius: 4px;
  background-color: var(--colorBlueGray1000);
`;

interface Props {
  animationDelay?: number;
}

const ModeSkeleton: FC<Props> = ({ animationDelay }) => {
  return (
    <Wrapper animationDelay={animationDelay}>
      <Box display="flex" gap="small" alignItems="center">
        <IconSkeleton />
        <TextSkeleton />
      </Box>
    </Wrapper>
  );
};

export default ModeSkeleton;
